import { useMemo, useState } from 'react';
import Helmet from '../lib/Helmet';
import { CATALOGUE } from '../data/catalogue';
import { PRICES, STOCK, RATES, GST_RATE } from '../data/pricing';
import { SERIES } from '../data/highlights';
import { pickGuideModels, usedSources } from '../data/guideInverter';
import { EXAMPLE, withGst, bill } from '../data/guideInstall';
import { VRV_SEO, VRV_UPDATED, VRV_SOURCES, VRV_HOME_HP, vrvContent, costText, tonOf } from '../data/guideVRV';
import { GuideHeader, GuideBody, ToolCard, Choice, Rich } from '../components/guide/GuideParts';
import VrvHouse from '../components/guide/VrvHouse';

// Route: /blog/vrv-vs-split-ac — AC guide 7 (26 Oct 2026), in the new layout
// from the structure mockup. Every word comes from vrvContent() in
// data/guideVRV.js (Saheb's answers of 25 Oct 2026 and Daikin's VRV Home
// page), which scripts/guide-pages.js reads too.

function CostTool({ tool }) {
  const [hp, setHp] = useState(5);
  return (
    <ToolCard title={tool.title}>
      <Choice label="VRV size" value={hp} onChange={setHp}
        options={VRV_HOME_HP.map((u) => ({ value: u.hp, label: `${u.hp} HP (${tonOf(u.kw)} ton)` }))} />
      <p className="rounded-xl bg-gray-50 p-3.5 text-[17px] leading-snug text-gray-900" aria-live="polite"><Rich text={costText(hp)} /></p>
    </ToolCard>
  );
}

export default function VRVGuide() {
  const { c, S } = useMemo(() => {
    const g = pickGuideModels({ catalogue: CATALOGUE, prices: PRICES, stock: STOCK, series: SERIES });
    const installEach = bill(withGst(RATES, GST_RATE), EXAMPLE).total;
    const content = vrvContent(g.five, installEach);
    return { c: content, S: usedSources(VRV_SOURCES, content) };
  }, []);

  return (
    <>
      <Helmet>
        <title>{VRV_SEO.title}</title>
        <meta name="description" content={VRV_SEO.meta} />
        <meta property="og:title" content={VRV_SEO.title} />
        <meta property="og:description" content={VRV_SEO.meta} />
      </Helmet>
      <main className="bg-white pb-16 pt-16 lg:pt-20">
        <article className="mx-auto max-w-[760px] px-4 text-base leading-relaxed text-gray-900">
          <GuideHeader seo={VRV_SEO} updated={VRV_UPDATED} crumb={VRV_SEO.crumb} />
          <GuideBody c={c} sources={S} current="vrv-vs-split-ac" ctaSource="guide_vrv"
            ctaTitle="Planning VRV for your home?"
            watch={<VrvHouse watch={c.watch} sources={S} />}
            tool={<CostTool tool={c.tool} />} />
        </article>
      </main>
    </>
  );
}
